/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectProgressCreateProgressPost } from '../fn/project-progress/api-project-progress-create-progress-post';
import { ApiProjectProgressCreateProgressPost$Params } from '../fn/project-progress/api-project-progress-create-progress-post';
import { apiProjectProgressCreateProgressPost$Plain } from '../fn/project-progress/api-project-progress-create-progress-post-plain';
import { ApiProjectProgressCreateProgressPost$Plain$Params } from '../fn/project-progress/api-project-progress-create-progress-post-plain';
import { apiProjectProgressDeleteProjectProgressDelete } from '../fn/project-progress/api-project-progress-delete-project-progress-delete';
import { ApiProjectProgressDeleteProjectProgressDelete$Params } from '../fn/project-progress/api-project-progress-delete-project-progress-delete';
import { apiProjectProgressDeleteProjectProgressDelete$Plain } from '../fn/project-progress/api-project-progress-delete-project-progress-delete-plain';
import { ApiProjectProgressDeleteProjectProgressDelete$Plain$Params } from '../fn/project-progress/api-project-progress-delete-project-progress-delete-plain';
import { apiProjectProgressGetProjectProgressesPost } from '../fn/project-progress/api-project-progress-get-project-progresses-post';
import { ApiProjectProgressGetProjectProgressesPost$Params } from '../fn/project-progress/api-project-progress-get-project-progresses-post';
import { apiProjectProgressGetProjectProgressesPost$Plain } from '../fn/project-progress/api-project-progress-get-project-progresses-post-plain';
import { ApiProjectProgressGetProjectProgressesPost$Plain$Params } from '../fn/project-progress/api-project-progress-get-project-progresses-post-plain';
import { apiProjectProgressUpdateProgressPost } from '../fn/project-progress/api-project-progress-update-progress-post';
import { ApiProjectProgressUpdateProgressPost$Params } from '../fn/project-progress/api-project-progress-update-progress-post';
import { apiProjectProgressUpdateProgressPost$Plain } from '../fn/project-progress/api-project-progress-update-progress-post-plain';
import { ApiProjectProgressUpdateProgressPost$Plain$Params } from '../fn/project-progress/api-project-progress-update-progress-post-plain';
import { CreateProjectProgressCommandResult } from '../models/create-project-progress-command-result';
import { DeleteProjectProgressCommandResult } from '../models/delete-project-progress-command-result';
import { GetProjectProgressQueryResult } from '../models/get-project-progress-query-result';
import { UpdateProjectProgressCommandResult } from '../models/update-project-progress-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectProgressService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectProgressGetProjectProgressesPost()` */
  static readonly ApiProjectProgressGetProjectProgressesPostPath = '/api/ProjectProgress/GetProjectProgresses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressGetProjectProgressesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressGetProjectProgressesPost$Plain$Response(params?: ApiProjectProgressGetProjectProgressesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectProgressQueryResult>> {
    return apiProjectProgressGetProjectProgressesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressGetProjectProgressesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressGetProjectProgressesPost$Plain(params?: ApiProjectProgressGetProjectProgressesPost$Plain$Params, context?: HttpContext): Observable<GetProjectProgressQueryResult> {
    return this.apiProjectProgressGetProjectProgressesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectProgressQueryResult>): GetProjectProgressQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressGetProjectProgressesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressGetProjectProgressesPost$Response(params?: ApiProjectProgressGetProjectProgressesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectProgressQueryResult>> {
    return apiProjectProgressGetProjectProgressesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressGetProjectProgressesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressGetProjectProgressesPost(params?: ApiProjectProgressGetProjectProgressesPost$Params, context?: HttpContext): Observable<GetProjectProgressQueryResult> {
    return this.apiProjectProgressGetProjectProgressesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectProgressQueryResult>): GetProjectProgressQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectProgressCreateProgressPost()` */
  static readonly ApiProjectProgressCreateProgressPostPath = '/api/ProjectProgress/CreateProgress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressCreateProgressPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressCreateProgressPost$Plain$Response(params?: ApiProjectProgressCreateProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectProgressCommandResult>> {
    return apiProjectProgressCreateProgressPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressCreateProgressPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressCreateProgressPost$Plain(params?: ApiProjectProgressCreateProgressPost$Plain$Params, context?: HttpContext): Observable<CreateProjectProgressCommandResult> {
    return this.apiProjectProgressCreateProgressPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectProgressCommandResult>): CreateProjectProgressCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressCreateProgressPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressCreateProgressPost$Response(params?: ApiProjectProgressCreateProgressPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectProgressCommandResult>> {
    return apiProjectProgressCreateProgressPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressCreateProgressPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressCreateProgressPost(params?: ApiProjectProgressCreateProgressPost$Params, context?: HttpContext): Observable<CreateProjectProgressCommandResult> {
    return this.apiProjectProgressCreateProgressPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectProgressCommandResult>): CreateProjectProgressCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectProgressUpdateProgressPost()` */
  static readonly ApiProjectProgressUpdateProgressPostPath = '/api/ProjectProgress/UpdateProgress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressUpdateProgressPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressUpdateProgressPost$Plain$Response(params?: ApiProjectProgressUpdateProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectProgressCommandResult>> {
    return apiProjectProgressUpdateProgressPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressUpdateProgressPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressUpdateProgressPost$Plain(params?: ApiProjectProgressUpdateProgressPost$Plain$Params, context?: HttpContext): Observable<UpdateProjectProgressCommandResult> {
    return this.apiProjectProgressUpdateProgressPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectProgressCommandResult>): UpdateProjectProgressCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressUpdateProgressPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressUpdateProgressPost$Response(params?: ApiProjectProgressUpdateProgressPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectProgressCommandResult>> {
    return apiProjectProgressUpdateProgressPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressUpdateProgressPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressUpdateProgressPost(params?: ApiProjectProgressUpdateProgressPost$Params, context?: HttpContext): Observable<UpdateProjectProgressCommandResult> {
    return this.apiProjectProgressUpdateProgressPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectProgressCommandResult>): UpdateProjectProgressCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectProgressDeleteProjectProgressDelete()` */
  static readonly ApiProjectProgressDeleteProjectProgressDeletePath = '/api/ProjectProgress/DeleteProjectProgress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressDeleteProjectProgressDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressDeleteProjectProgressDelete$Plain$Response(params?: ApiProjectProgressDeleteProjectProgressDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectProgressCommandResult>> {
    return apiProjectProgressDeleteProjectProgressDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressDeleteProjectProgressDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressDeleteProjectProgressDelete$Plain(params?: ApiProjectProgressDeleteProjectProgressDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectProgressCommandResult> {
    return this.apiProjectProgressDeleteProjectProgressDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectProgressCommandResult>): DeleteProjectProgressCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectProgressDeleteProjectProgressDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressDeleteProjectProgressDelete$Response(params?: ApiProjectProgressDeleteProjectProgressDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectProgressCommandResult>> {
    return apiProjectProgressDeleteProjectProgressDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectProgressDeleteProjectProgressDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectProgressDeleteProjectProgressDelete(params?: ApiProjectProgressDeleteProjectProgressDelete$Params, context?: HttpContext): Observable<DeleteProjectProgressCommandResult> {
    return this.apiProjectProgressDeleteProjectProgressDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectProgressCommandResult>): DeleteProjectProgressCommandResult => r.body)
    );
  }

}
